<template>
  <section class="price">
    <h1>Prijs:</h1>
    <p v-if="priceError">Geen prijscalculatie mogelijk</p>
    <div v-else>
      <span v-if="files.length === 1 && !isMailing"
        >Per stuk: {{ singlePrice }}</span
      >
      <span class="total" v-if="isMailing">{{ singlePrice }}</span>
      <span class="total" v-else>Totaal: {{ totalPrice }}</span>
    </div>
  </section>
</template>

<script>
export default {
  props: ['product', 'files'],
  data() {
    return {
      price: 0
    }
  },
  computed: {
    isMailing() {
      // Check if this is a mailing order
      return this.files[0]?.productSpecs?.priceType === 'mailing'
    },
    singlePrice() {
      if (!this.files[0].price) {
        return ''
      } else {
        return '€ ' + this.files[0].price.toFixed(2).replace('.', ',')
      }
    },
    totalPrice() {
      let fullPrice = 0
      this.files.forEach((file) => {
        let totelFilePrice = file.price * file.quantity

        fullPrice += totelFilePrice
      })

      //      fullPrice = fullPrice.toFixed(2).replace('.', ',')
      return '€ ' + fullPrice.toFixed(2).replace('.', ',')
    },
    priceError() {
      if (
        this.files.some((file) => {
          return (
            file.price === 'NA' ||
            file.status === 'READY_NOT_ANALYZED' ||
            file.status == 'READY_PASSWORD_PROTECTED'
          )
        })
      ) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.price {
  display: flex;
  flex-wrap: wrap;
}

h1 {
  font-weight: 600;
  color: #4f4f4f;
  font-size: 0.82rem;
  margin-bottom: 0px;
  padding-right: 10px;
}

span {
  text-wrap: nowrap;
  display: inline-block;
  padding-right: 20px;
  //height: 45px;
  //line-height: 45px;
}

.title {
  font-weight: 600;
  flex-grow: 1;
}

.price-text {
  font-size: 19px;
  //padding-top: 5px;
  font-weight: 500;
}

.sup {
  top: -1em;
  font-size: 45%;
  padding-left: 5px;
}

.price {
  display: flex;
  align-items: center;
  font-weight: 500;
}
</style>
